module.exports = __webpack_public_path__ + "static/IMG_20190409_151344-44e970438dd0cde2e5ad9b8e294063f1.webp";